import React, { useEffect, useState, Fragment } from 'react';
import { Button } from '@nextui-org/react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSessions } from '../../redux/features/sessions/sessionActions';
import { Link, useNavigate } from 'react-router-dom';
import SessionCard from '../SessionCard/SessionCard';
import { message } from 'antd';
import ErrorBoundary from '../../utils/Errorboundary';

function SessionSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.session);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAllSessions())
        .unwrap()
        .catch((err) =>
          message.error(err.error || 'Failed to fetch sessions data')
        );
    };
    fetchData();
  }, [dispatch]);

  // const sliceData = data?.events?.slice(0, 3)
  const filteredData = data?.events
    ?.filter(
      (session) =>
        session?.event_status === 'complete' && session?.status === 'active'
    )
    .slice(0, 9);

  const IsupcommingSession = data?.events?.filter(
    (session) =>
      session?.event_status === 'upcoming' && session?.status === 'active'
  );

  const navigateToSession = (id) => {
    if (!id) {
      message.error('Session ID not found');
    }
    navigate('/session/all');
  };

  return (
    <div className="font-poppins p-1 md:p-6 mx-auto lg:max-w-full md:max-w-3xl sm:max-w-full ">
      {/* title */}
      {IsupcommingSession?.length > 0 && (
        <h5 className="mt-6 mb-9 text-white font-poppins text-xl md:text-2xl font-bold">
          Discover Best of Forex Online Sessios
        </h5>
      )}

      {/* card */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 rounded-lg">
        {IsupcommingSession?.length > 0 && (
          <Fragment>
            {filteredData?.map((session, index) => (
              <Fragment key={index}>
                <ErrorBoundary>
                  <SessionCard
                    id={session?.eventId}
                    imageSrc={session?.coverImage[0]?.url}
                    altText={session?.coverImage[0]?.imageName}
                    eventName={session?.event_name}
                    presenter={session?.presenter}
                    description={session?.description}
                    language={session?.medium}
                    category={session?.category}
                    date={session?.date}
                    startTime={session?.startTime}
                    endTime={session?.endTime}
                    url={session?.zoomLink}
                    videoLink={session?.video[0]?.url}
                    youtubeLink={session?.YoutubeLinks?.url}
                    isCollection={session?.isCollection}
                    eventCollectionId={session?.eventCollectionId}
                  />
                </ErrorBoundary>
              </Fragment>
            ))}
          </Fragment>
        )}
      </div>

      {/* btn */}
      <div className="font-poppins space-x-4 space-y-4 text-center mt-10 mb-5">
        {IsupcommingSession?.length > 0 && (
          <Button
            size="sm"
            onPress={navigateToSession}
            className="border-btn-color font-poppins text-white md:text-sm text-mobile-font"
            variant="bordered"
          >
            View all
          </Button>
        )}
      </div>
    </div>
  );
}

export default SessionSection;
